import { QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 10 * 60 * 1000,
			refetchOnMount: true,
			refetchOnWindowFocus: true,
			experimental_prefetchInRender: true,
			retry: (failureCount, error) => {
				if (error instanceof AxiosError && (error.status === 401 || error.status === 403))
					return false;
				return failureCount < 2;
			}
		}
	}
});
